angular.module("rgpd")

    .controller('RgpdListCtrl', ['$stateParams', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$state', '$uibModal', 'logService', function ($stateParams, $rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $state, $uibModal, logService) {

        Restangular.all('Persons/AllPersons').getList().then(function (persons) {
            logService.debug(persons);
            $scope.selectPersons = persons;
            $scope.selectPersons.unshift({
                id: null,
                name: $filter('translate')('informations.all')
            });
        });        
        $scope.allowWrite = LoginService.permissionExist("RGPD");
        $rootScope.title = $filter('translate')('rgpd.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('rgpd.list') }
        ];

        $scope.search = {
            email: "",
            date_from: null,
            date_to: null,
        };

        $scope.gridOption = {
            pdfTitle: $filter('translate')('rgpd.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            enableFiltering: false,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    name: 'date', displayName: $filter('translate')('rgpd.date'), maxWidth: 125, minWidth: 80,
                    type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                    customFormatFn: function (value) {
                        if (value !== null) {
                            var fecha = new Date(value);
                            return $filter('date')(fecha, 'dd/MM/yyyy HH:mm');
                        }
                        return "";
                    }, enableFiltering: false, enableColumnMenu: false
                },
                {
                    name: 'date_end', displayName: $filter('translate')('rgpd.date_end'), maxWidth: 125, minWidth: 80,
                    type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                    customFormatFn: function (value) {
                        if (value !== null) {
                            var fecha = new Date(value);
                            return $filter('date')(fecha, 'dd/MM/yyyy HH:mm');
                        }
                        return "";
                    },enableFiltering: false, enableColumnMenu: false
                },
                { name: 'email', displayName: $filter('translate')('rgpd.email'), enableFiltering: false, enableHiding: false, enableColumnMenu: false },
                {
                    name: 'FK_RGPD_persons.name',
                    displayName: $filter('translate')('rgpd.person'), enableFiltering: false, enableHiding: false, enableColumnMenu: false,
                    customFormatFn: function (value) {
                        logService.debug(value);
                        return value;
                    }, cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.FK_RGPD_persons.name}} {{row.entity.FK_RGPD_persons.surname}} {{row.entity.FK_RGPD_persons.lastname}}</div>'
                },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('rgpd.cancel_unsubscribe'), action: 'ng-click="grid.appScope.cancelUnsubscribe(row.entity);" ng-if="grid.appScope.allowWrite && row.entity.date_end == null"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },
            ],
            getData: function (options) {
                options.email = $scope.search.email;
                options.date_from = $scope.search.date_from;
                options.date_to = $scope.search.date_to;
                options.person_id = $scope.search.person_id;
                return Restangular.all('rgpd').getList(options);
            }
        };

        $scope.cancelUnsubscribe = function (entity) {
            modalService.confirm({
                title: $filter('translate')('rgpd.cancel_unsubscribe_title'),
                message: $filter('translate')('rgpd.cancel_unsubscribe_message') + " " + entity.email + "?",
                onAccept: function () {

                    Restangular.all('rgpd').customPOST({}, "CancelUnsubscribe", { id: entity.id}).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('rgpd.cancel_unsubscribe_success'));
                            $scope.gridOption.loadData();
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            });

        };

    }])

;